import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, signal } from '@angular/core';

import { FullStoryEventDirective } from '@directives/fullstory-event.directive';

@Component({
  selector: 'hsc-sample-contract-modal',
  imports: [CommonModule, FullStoryEventDirective],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <div class="flex flex-col items-center justify-center gap-6" id="sample-plan">
      <div class="border-charcoal mx-auto flex flex-col items-center justify-center gap-4 border-t-1 pt-6">
        <div class="flex flex-col items-center justify-center gap-0">
          <div>The details of a breakdown situation may impact coverage</div>
          <div>See sample plan for full details and exclusions.</div>
        </div>
        <h2 class="bolt-heading-sm">Sample plan</h2>
        <button
          class="flex h-12 w-12 cursor-pointer items-center justify-center border-none bg-transparent p-0"
          type="button"
          hscFsEventName="Sample Contract Opened"
          aria-label="Open sample contract"
          (click)="showModal.set(true)"
        >
          <img src="/icons/document-icon.svg" alt="document-filled" />
        </button>
        <bolt-modal
          [open]="showModal()"
          (bolt-modal-primary-button-click)="showModal.set(false)"
          id="contentModal"
          type="content"
          heading="Sample Contract"
          primarybutton="Close"
        >
          <!-- Use object to embed PDF for modern browser previewing  -->
          <object
            class="h-[70vh] w-[640px] drop-shadow-lg"
            data="/sample-contract.pdf"
            type="application/pdf"
            aria-label="Sample contract PDF"
          >
            <!-- provide PDF download if browser doesn't support inline rendering -->
            <p class="p-10 text-center">
              Sorry, your browser does not appear to support inline PDF viewing. <br />
              Click <a href="/sample-contract.pdf" target="_blank" rel="noopener">here</a> instead to download.
            </p>
          </object>
        </bolt-modal>
      </div>
    </div>
  `,
})
export class SampleContractModal {
  readonly showModal = signal(false);
}
